import type { ReactNode } from 'react';
import { Spinner } from '../BrowserPrimitives';
import { LINK_BUTTON_CLASS } from '../browserStyles';

interface FilterBarProps {
    label: string;
    chips: ReactNode;
    error?: string | null;
    isUpdating: boolean;
    showClear: boolean;
    onClear: () => void;
}

// The active tab's filter controls, laid out inline in the browser toolbar.
export function FilterBar({
    label,
    chips,
    error = null,
    isUpdating,
    showClear,
    onClear
}: FilterBarProps) {
    return (
        <>
            <div role="group" aria-label={label} className="flex shrink-0 items-center gap-2">
                {chips}
            </div>
            <div className="flex min-w-0 items-center gap-3 text-[12px]">
                {isUpdating && <Spinner className="h-3 w-3" />}
                {error && (
                    <span role="alert" className="truncate text-red-600">
                        {error}
                    </span>
                )}
                {showClear && (
                    <button
                        type="button"
                        onClick={onClear}
                        className={`${LINK_BUTTON_CLASS} shrink-0`}
                    >
                        Clear filters
                    </button>
                )}
            </div>
        </>
    );
}
